export const retrieveLocalStorageItem = (itemName, storageType = 'session') => {
  const item = storageType === 'session' ? sessionStorage.getItem(itemName) : localStorage.getItem(itemName)
  return item
}

export const removeLocalStorageItem = (itemName, storageType = 'session') => {
  storageType === 'session' ? sessionStorage.removeItem(itemName) : localStorage.removeItem(itemName)
}

export const setLocalStorageItem = (itemName, item, storageType = 'session') => {
  storageType === 'session' ? sessionStorage.setItem(itemName, item) : localStorage.setItem(itemName, item)
}



// WEBPACK FOOTER //
// ./src/utils/localStorage.js